<template>
  <div class="mb-20">
    
      <label class="font-weight-normal">
        {{ $t('seleccionar expo') }}
        <span class="required">*</span>
      </label>

      <select
        class="form-control"
        v-model="expoSeleccionada"       
        @change="expoSelected(expoSeleccionada)"
      >       
        <option v-for="expo in currentOpenExpos.data" :key="expo.id" :value="expo.id">{{expo.name}}</option>
      </select>
      <small>{{ $t('ver_expos_disponibles')}}.</small>    
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "Inscripcions-opened-comp",
  props: ["seleccionada"],
  data: () => ({
    expoSeleccionada: null   
  }),
  methods: {
    ...mapActions("inscription", ["getUserOpenExpos", "getExpo"]),
    expoSelected(event) {     
      if (event === null) {
        return;
      }
      this.getExpo(event).then( res => { 
        if (this.selectedExpo.data.length === 0) {
          this.$emit('emitSetCurrentExpo', { id: 0, data: null });
        } else {
          this.$emit('emitSetCurrentExpo', { id: event , data : this.selectedExpo.data });
        }     
      })

    }
  },  
  computed: {
    ...mapState("inscription", ["currentOpenExpos", "selectedExpo" ])
  },
  mounted() {
    //asignamos la expo que tenemos seleccionada, por defecto null
      this.expoSeleccionada = this.seleccionada;
    
  }
};
</script>

<style>
</style>